import { render } from "./ClipboardNotification.vue.js?vue&type=template&id=2d730dd1&scoped=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./ClipboardNotification.vue?vue&type=template&id=2d730dd1&scoped=true"
import script from "./ClipboardNotification.vue.js?vue&type=script&lang=js!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./ClipboardNotification.vue?vue&type=script&lang=js"
export * from "./ClipboardNotification.vue.js?vue&type=script&lang=js!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./ClipboardNotification.vue?vue&type=script&lang=js"

import "./ClipboardNotification.vue.css?vue&type=style&index=0&id=2d730dd1&scoped=true&lang=css!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./ClipboardNotification.vue?vue&type=style&index=0&id=2d730dd1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d730dd1"],['__file',"public/assets/youthletics/components/ClipboardNotification.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d730dd1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d730dd1', __exports__)) {
    api.reload('2d730dd1', __exports__)
  }
  
  module.hot.accept("./ClipboardNotification.vue.js?vue&type=template&id=2d730dd1&scoped=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./ClipboardNotification.vue?vue&type=template&id=2d730dd1&scoped=true", () => {
    api.rerender('2d730dd1', render)
  })

}


export default __exports__